import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Logining2 from '@/components/Logining2'
import BindPhone from '@/components/bind/BindPhone'
import BindPhoneVerify from '@/components/bind/BindPhoneVerify'
import BindSetCallForward from '@/components/bind/BindSetCallForward'
import BindDailTry from '@/components/bind/BindDailTry'
import BindChangeNumNotify from '@/components/bind/BindChangeNumNotify'
import BindDailTryVerify from '@/components/bind/BindDailTryVerify'
import CallDetail from '@/components/CallDetail'
import BasicSetting from '../components/setting/BasicSetting'
import AIPatternPage from '../components/setting/AIPatternPage'
import VipSettingPage from '../components/setting/VipSettingPage'
import AISoundPage from '../components/setting/AISoundPage'
import VipRefusePage from '../components/setting/VipRefusePage'
import VipProloguePage from '../components/setting/VipProloguePage'
import VipPrologueEditPage from '../components/setting/VipPrologueEditPage'
import ServicePage from '../components/setting/ServicePage'
import supplierAllBack from '../components/supplierAllBack'
import CloseAiPage from '../components/setting/CloseAiPage'
import BindSuccess from '../components/bind/BindSuccess'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  // base: '/webcdn/aicall/',
  routes: [
    {
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        title: '智能接听助理',
        keepAlive: true
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Logining2,
      meta: {
        title: '智能接听助理'
      }
    },
    {
      path: '/bind_phone',
      name: 'bind_phone',
      component: BindPhone,
      meta: {
        title: '开通服务'
      }
    },
    {
      path: '/bind_phone_verify',
      name: 'bind_phone_verify',
      component: BindPhoneVerify,
      meta: {
        title: '开通服务'
      }
    },
    {
      path: '/bind_call_forward',
      name: 'bind_call_forward',
      component: BindSetCallForward,
      meta: {
        title: '开通服务'
      }
    },
    {
      path: '/bind_dail_try',
      name: 'bind_dail_try',
      component: BindDailTry,
      meta: {
        title: '开通服务'
      }
    },
    {
      path: '/bind_dail_try_verify',
      name: 'bind_dail_try_verify',
      component: BindDailTryVerify,
      meta: {
        title: '开通服务'
      }
    },
    {
      path: '/calldetail',
      name: 'calldetail',
      component: CallDetail,
      meta: {
        title: '话单详情',
        keepAlive: true
      }
    },
    {
      path: '/basic_setting',
      name: 'basic_setting',
      component: BasicSetting,
      meta: {
        title: '基础设置'
      }
    },
    {
      path: '/ai_pattern_page',
      name: 'ai_pattern_page',
      component: AIPatternPage,
      meta: {
        title: '代接接听模式'
      }
    },
    {
      path: '/vip_setting_page',
      name: 'vip_setting_page',
      component: VipSettingPage,
      meta: {
        title: '会员专属设置'
      }
    },
    {
      path: '/ai_sound_page',
      name: 'ai_sound_page',
      component: AISoundPage,
      meta: {
        title: '选择助理声音'
      }
    },
    {
      path: '/vip_refuse_page',
      name: 'vip_refuse_page',
      component: VipRefusePage,
      meta: {
        title: '谢绝骚扰来电设置'
      }
    },
    {
      path: '/vip_prologue_page',
      name: 'vip_prologue_page',
      component: VipProloguePage,
      meta: {
        title: '自定义接听开场白'
      }
    },
    {
      path: '/vip_prologue_edit_page',
      name: 'vip_prologue_edit_page',
      component: VipPrologueEditPage,
      meta: {
        title: '自定义开场白编辑'
      }
    },
    {
      path: '/service_page',
      name: 'service_page',
      component: ServicePage,
      meta: {
        title: '服务开关'
      }
    },
    {
      path: '/supplierallback',
      name: 'supplierallback',
      component: supplierAllBack,
      meta: {
        title: '智能接听助理'
      }
    },
    {
      path: '/changenumnotify',
      name: 'changenumnotify',
      component: BindChangeNumNotify,
      meta: {
        title: '更换号码'
      }
    },
    {
      path: '/closeaipage',
      name: 'closeaipage',
      component: CloseAiPage,
      meta: {
        title: '停用服务'
      }
    },
    {
      path: '/bindsuccess',
      name: 'bindsuccess',
      component: BindSuccess,
      meta: {
        title: '开通服务',
        keepAlive: true
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js